module.exports = __webpack_public_path__ + "static/media/3221.945a636f.jpg";